import React from 'react';
import { X } from 'lucide-react';

interface ExpiredHoldModalProps {
  isOpen: boolean;
  onRetry: () => void;
  onClose: () => void;
}

export const ExpiredHoldModal: React.FC<ExpiredHoldModalProps> = ({
  isOpen,
  onRetry,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6">
      {/* Overlay oscuro */}
      <div
        className="absolute inset-0 bg-black bg-opacity-80"
        onClick={onClose}
      />

      {/* Modal Card */}
      <div className="relative bg-dark-card rounded-[18px] p-12 max-w-md w-full flex flex-col items-center gap-6 z-10">
        {/* Icono de expiración */}
        <div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center">
          <X className="w-12 h-12 text-red-500" />
        </div>

        {/* Título */}
        <h2 className="text-3xl font-bebas text-red-500 text-center">
          TU RESERVA EXPIRÓ
        </h2>

        {/* Mensaje */}
        <p className="text-base font-montserrat text-gray-400 text-center">
          El tiempo de reserva se agotó. El horario quedó liberado para otros usuarios.
        </p>

        {/* Botones */}
        <div className="w-full flex flex-col gap-3 mt-2">
          {/* Botón primario - Reintentar */}
          <button
            onClick={onRetry}
            className="w-full h-14 bg-primary text-dark-bg font-bebas text-lg rounded-full hover:bg-primary/90 transition-colors"
          >
            REINTENTAR RESERVA
          </button>

          {/* Botón secundario - Volver */}
          <button
            onClick={onClose}
            className="w-full h-14 bg-transparent border border-gray-700 text-gray-400 font-bebas text-lg rounded-full hover:border-gray-600 transition-colors"
          >
            VOLVER A CANCHAS
          </button>
        </div>
      </div>
    </div>
  );
};
